import { ReactNode } from 'react'

import { useIncidentDescription } from '../../../../features/incident-drawer/feed/hooks/useIncidentDescription'

import { Box, Flex } from '@chakra-ui/react'

import { IncidentCreatorType } from '@/features/incident-drawer'
import { IncidentType } from '@/graphql/generated/schemas'
import { DeviceType } from '@/graphql/generated/schemas'

import { ButtonTag } from '../../ButtonTag'
import { DeviceIcon } from './DeviceIcon'
import { FloorIcon } from './FloorIcon'
import { ManualIncidentDescription } from './ManualIncidentDescription'

interface IncidentDescriptionIProps {
  type: IncidentType | null
  description?: string
  floorName?: string
  floorId?: string
  deviceName?: string
  deviceType?: DeviceType
  deviceId?: string
  showButtonTag?: boolean
  creator?: IncidentCreatorType
  manualIncidentCategoryName?: string
  name?: string
}

export const IncidentDescription = ({
  type,
  creator,
  description,
  floorName,
  floorId,
  deviceName,
  deviceType,
  deviceId,
  showButtonTag = true,
  manualIncidentCategoryName,
  name,
}: IncidentDescriptionIProps) => {
  const { message, onDeviceClick, onFloorClick } = useIncidentDescription({
    deviceId,
    deviceType,
    floorId,
    type,
  })

  switch (type) {
    case IncidentType.Tailgating:
      return (
        <Flex direction='column'>
          <span>{message}</span>
        </Flex>
      )
    // Manual incidents have IncidentType set to null
    case null:
      return (
        <ManualIncidentDescription
          creator={creator}
          description={description}
          manualIncidentCategoryName={manualIncidentCategoryName}
        />
      )
    default:
      return (
        <Box
          as='span'
          mt='5px'
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
            rowGap: '2px',
          }}
        >
          {/* Incident name */}
          <Box as='span' mr='1' verticalAlign='middle'>
            {`${name} was created from `}
          </Box>

          {/* Device name */}
          <IncidentTag
            icon={<DeviceIcon type={deviceType} />}
            name={deviceName}
            onClick={onDeviceClick}
            showButtonTag={showButtonTag}
          />

          <Box as='span' ml='1' mr='1' verticalAlign='middle'>
            on
          </Box>

          {/* Floor name */}
          <IncidentTag
            icon={<FloorIcon />}
            name={floorName}
            onClick={onFloorClick}
            showButtonTag={showButtonTag}
          />
        </Box>
      )
  }
}

interface IncidentTagIProps {
  icon: ReactNode
  name: string
  showButtonTag: boolean
  onClick: () => void
}

export const IncidentTag = ({
  icon,
  name,
  showButtonTag,
  onClick,
}: IncidentTagIProps) => {
  if (showButtonTag) {
    return (
      <Box
        alignItems='center'
        as='span'
        display='inline-flex'
        margin='2px'
        verticalAlign='middle'
      >
        <ButtonTag onClick={onClick}>
          {icon}
          {name}
        </ButtonTag>
      </Box>
    )
  }
  return (
    <Box
      alignItems='center'
      as='span'
      display='inline-flex'
      verticalAlign='middle'
    >
      {icon}
      <Box as='span' verticalAlign='middle'>
        {name}
      </Box>
    </Box>
  )
}
